export const LOREN_DATE = {
  analysisFormat: "D MMM YYYY",
  globalDateFormat: "D MMM YYYY, HH:mm",
  globalDateFormatWithSeconds: "D MMM YYYY, HH:mm:ss",
  currentValueFormat: "DD MMM HH:mm",
  chartDateFormat: "DD MMM",
  monthFormat: "MMMM YYYY",
  chartHourValues: "HH:mm",
  requestDefaultFormat: "YYYY-MM-DD HH24:MI:SS",
  tracesTimestampFormat: "YYYY-MM-DD HH:mm:ss",
  requestDefaultForm: "YYYY-MM-DD HH:mm",
};
